import React from 'react';
import { Box, Dialog, DialogContent, Drawer, IconButton, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

/**
 * Folha de edição que sobe por cima da tela atual (como o "Editar" das listas
 * do WhatsApp): puxador no topo, X à esquerda, título centralizado e a ação
 * (ex.: ✓ salvar) à direita. No desktop vira um diálogo comum.
 */
const BottomSheetDialog = ({ open, onClose, title, action, children }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const header = (
    <Stack direction="row" alignItems="center" sx={{ px: 1, py: 1 }}>
      <IconButton onClick={onClose} aria-label={t('close')}>
        <CloseIcon />
      </IconButton>
      <Typography variant="h6" noWrap sx={{ flex: 1, textAlign: 'center', minWidth: 0 }}>
        {title}
      </Typography>
      <Box sx={{ minWidth: 40, display: 'flex', justifyContent: 'flex-end' }}>{action}</Box>
    </Stack>
  );

  if (isDesktop) {
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" slotProps={{ paper: { sx: { maxHeight: '85vh', borderRadius: 3 } } }}>
        {header}
        <DialogContent sx={{ px: 2, pt: 1 }}>{children}</DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      // Mesmo zIndex dos Dialogs: abre por cima do diálogo atual e deixa os
      // diálogos abertos a partir dela (ex.: Adicionar à lista) por cima dela.
      sx={{ zIndex: theme.zIndex.modal }}
      slotProps={{
        paper: {
          sx: {
            height: 'calc(100% - 24px)',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            display: 'flex',
            flexDirection: 'column',
            // Só o conteúdo rola; o puxador e o cabeçalho ficam fixos.
            overflow: 'hidden',
          },
        },
      }}
    >
      <Box sx={{ width: 36, height: 4, borderRadius: 2, bgcolor: 'divider', mx: 'auto', mt: 1 }} />
      {header}
      <Box sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', px: 2, pt: 1, pb: 2 }}>{children}</Box>
    </Drawer>
  );
};

export default BottomSheetDialog;
